
namespace TabAurous.Reports {

  
    @Serenity.Decorators.registerClass()
    export class POSOpenConsignmentOutDetailedGrid extends Serenity.EntityGrid<TabAurous.Retail.POSApprovalItemsRow, any> {
        protected getColumnsKey() { return 'Retail.POSOpenConsignmentOutDetailed'; }
        protected getDialogType() { return TabAurous.Retail.POSApprovalItemsDialog; }
        protected getIdProperty() { return TabAurous.Retail.POSApprovalItemsRow.idProperty; }
        protected getInsertPermission() { return TabAurous.Retail.POSApprovalItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return TabAurous.Retail.POSApprovalItemsRow.localTextPrefix; }
        protected getService() { return TabAurous.Retail.OpenConsignmentOutDetailedService.baseUrl; }

        private chartContainer: JQuery;
        private chartPanel: Reports.LineChartPanel;
        constructor(container: JQuery) {
            super(container);

            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.addDateRangeFilter("TransDate", "Date");
            this.setTitle("");
        }

        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: OMS.FinancialYearRow.lookupKey,
                    multiple: true

                },
                field: 'FinancialYearId',
                title: 'Year',
                handler: w => {
                    var temp= [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).FinancialYearIds = temp;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                    }
                },
                
                cssClass: 'hidden-xs'
            });
            //filters.push({
            //    type: Serenity.LookupEditor,
            //    options: {
            //        lookupKey: OMS.CompanyRow.lookupKey,
            //        multiple: true

            //    },
            //    field: 'CompanyId',
            //    title: 'Company',
            //    handler: w => {
            //        var temp = [];
            //        var values = w.value;
            //        for (var i = 0; i < values.length; i++) {
            //            temp.push(parseInt(values[i]));
            //        } if (temp.length != 0) {
            //            (this.view.params as ReportFiltersRequest).CompanyIds = temp;
            //        }
            //    },

            //    cssClass: 'hidden-xs'
            //});
            
          

            return filters;
        } 

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
            this.view.setGrouping([{

                getter: 'LedgerName',
                displayTotalsRow: false,
            }])
            return grid;
        }

        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            //buttons.push({

            //    title: 'Print',
            //    icon: 'fa fa-print text-blue',
            //    //icon: 'fa-cloud-download',
            //    onClick: () => {
                    
            //        Common.ReportHelper.execute({
            //            reportKey: 'Reports.ApprovalRegister',
            //            params: {
            //                CompanyIds: this.view.params.CompanyIds,
            //                FinIds: this.view.params.FinancialYearIds,
            //                VendorIds: this.view.params.VendorIds,
            //                date:this.view.params.Criteria
            //            }
            //        });
            //    }
            //});
            buttons.push(Common.PdfExportHelper.createToolButton({
                grid: this,
                title: "Print",
                reportTitle: "Open Consignment ",
                onViewSubmit: () => this.onViewSubmit()
            }));
            return buttons;
        }
    }
}